import React from 'react';
import { SkuStyled, SkuGroup } from './Styled';
import { Title } from '../';

type DiffProps = {
  value: string;
  images: {
    medium: string;
  }[];
};

interface RadioProps {
  diffs: DiffProps[];
  onChange: (e: any) => void;
  name: string;
  type: string;
  typeSelected?: string;
}

const Sku = (props: RadioProps) => {
  const { diffs, onChange, name, type, typeSelected } = props;

  const renderDiff = diffs.map(({ value, images }) => {
    let children: string | JSX.Element = value;

    if (images) {
      children = <img key={images[0].medium} src={images[0].medium} width="72px" height="72px" />;
    }
    return (
      <li key={value}>
        <input
          type="radio"
          id={value}
          name={name}
          value={value}
          data-type={type}
          onChange={onChange}
          checked={value === typeSelected}
        />
        <label htmlFor={value}>{children}</label>
      </li>
    );
  });

  return (
    <SkuStyled>
      <Title fontSize={14}>selecione uma opção pra avaliar</Title>
      <SkuGroup>{renderDiff}</SkuGroup>
    </SkuStyled>
  );
};

Sku.defaultProps = {};

export default Sku;
export { Sku };
